export default __webpack_public_path__ + "static/media/home_title_mobile.b863ad51.svg";